module.exports = __webpack_public_path__ + "static/media/line-blue.aa395ecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/line-blue.svg
// module id = 744
// module chunks = 0